/** FAQ, Support, and Advertising page copy (Norwegian Bokmål). */
export const pagesMessagesNb = {
  faq: {
    pageTitle: "Ofte Stilte Spørsmål",
    pageSubtitle: "Finn svar på vanlige spørsmål om WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Svar på vanlige spørsmål om WasOK, produktskanning, personvern og vurderinger.",
    items: [
      {
        question: "Hvordan fungerer WasOK?",
        answer:
          "WasOK hjelper deg å huske hvilke produkter du likte eller ikke likte ved å skanne strekkoder og lagre vurderingene og notatene dine. Skann rett og slett strekkoden til et produkt, vurder det, legg til notater, og neste gang du skanner det samme produktet, ser du umiddelbart din tidligere vurdering.",
      },
      {
        question: "Lagres dataene mine i skyen?",
        answer:
          "Nei! Alle dataene dine lagres lokalt på enheten din. Vi synkroniserer ikke informasjonen din til skyen, noe som betyr at handlehistorikken og produktmeningene dine forblir helt private. Dette betyr imidlertid også at du bør sikkerhetskopiere enheten din hvis du vil bevare dataene dine.",
      },
      {
        question: "Trenger jeg internettforbindelse for å bruke WasOK?",
        answer:
          "Nei, WasOK fungerer helt uten nett. Siden alle dataene dine lagres lokalt på enheten din, kan du skanne produkter, legge til vurderinger og se historikken din uten noen internettforbindelse.",
      },
      {
        question: "Kan jeg bruke WasOK for alle typer produkter?",
        answer:
          "Ja! WasOK fungerer med alle produkter som har en strekkode. Enten det er mat, kosmetikk, husholdningsartikler, elektronikk eller noe annet med en strekkode, kan du skanne det og lagre meningene dine.",
      },
      {
        question: "Hvordan skanner jeg en strekkode?",
        answer:
          "Åpne rett og slett WasOK-appen og trykk på skanneknappen. Rett kameraet mot produktets strekkode, og appen vil automatisk oppdage og skanne den. Sørg for at strekkoden er godt belyst og i fokus for best resultat.",
      },
      {
        question: "Kan jeg legge til bilder i produktvurderingene mine?",
        answer:
          "Ja! Du kan legge ved bilder til enhver produktvurdering. Dette er spesielt nyttig for å huske emballasjedetaljer, ingredienslister eller annen visuell informasjon som kan hjelpe deg å huske hvorfor du likte eller ikke likte et produkt.",
      },
      {
        question: "Hvilken informasjon kan jeg lagre om produkter?",
        answer:
          "Du kan lagre vurderinger (1-5 stjerner), tekstnotater, bilder, prisen du betalte, hvor du kjøpte det, og egendefinerte kategorier. Denne omfattende informasjonen hjelper deg å ta informerte beslutninger når du handler.",
      },
      {
        question: "Kan jeg lage handlelister?",
        answer:
          "Ja! WasOK lar deg lage handlelister fra produkter du allerede har vurdert. Dette gjør det enkelt å huske hvilke produkter du elsket og ønsker å kjøpe igjen.",
      },
      {
        question: "Hvordan organiserer jeg produktene mine?",
        answer:
          "Du kan organisere produkter ved hjelp av egendefinerte kategorier. Du kan for eksempel lage kategorier som 'Snacks', 'Kaffe', 'Hudpleie' eller 'Rengjøringsprodukter'. Dette gjør det enkelt å bla gjennom vurderingene dine etter type.",
      },
      {
        question: "Er WasOK gratis å bruke?",
        answer:
          "Ja, WasOK er helt gratis å laste ned og bruke. Det finnes ingen kjøp i appen, abonnementer eller skjulte avgifter. Vi tror alle bør ha tilgang til en privat måte å huske produktpreferansene sine på.",
      },
      {
        question: "Er WasOK tilgjengelig?",
        answer:
          "WasOK er utformet for å kunne brukes av så mange mennesker som mulig. Appen inkluderer tilgjengelighetsfunksjoner som skjermleserstøtte, skalerbar tekst og en valgfri høykontrastmodus.",
      },
      {
        question: "Hva skjer hvis jeg avinstallerer appen?",
        answer:
          "Siden alle data lagres lokalt på enheten din, vil avinstallering av appen slette alle produktvurderingene, notatene og handlelistene dine. Sørg for å eksportere dataene dine hvis du vil beholde en sikkerhetskopi før du avinstallerer.",
      },
      {
        question: "Kan jeg eksportere dataene mine?",
        answer:
          "Ja, WasOK lar deg eksportere dataene dine for sikkerhetskopieringsformål. Du kan eksportere alle vurderingene dine til en fil som du kan lagre på enheten din eller skylagringen du velger.",
      },
      {
        question: "Sporer WasOK plasseringen min?",
        answer:
          "Nei, WasOK sporer ikke plasseringen din. Selv om du manuelt kan angi navnet på butikken der du kjøpte et produkt, bruker appen ikke GPS eller posisjonstjenester.",
      },
      {
        question: "Kan jeg bruke WasOK på flere enheter?",
        answer:
          "For øyeblikket synkroniserer ikke WasOK mellom enheter siden alle data lagres lokalt. Hver enhet vil ha sin egen separate database med produkter og vurderinger.",
      },
      {
        question: "Hva om en strekkode ikke skanner?",
        answer:
          "Hvis en strekkode ikke skanner, sørg for at den er godt belyst og i fokus. Du kan også prøve å rengjøre kameralinsen. Hvis strekkoden er skadet eller uklar, kan du kanskje angi strekkodenummeret manuelt.",
      },
    ],
    cta: {
      heading: "Har du fortsatt spørsmål?",
      body: "Ta kontakt med supportteamet vårt — vi hjelper deg gjerne.",
      button: "Kontakt support",
    },
  },
  support: {
    pageTitle: "Support",
    seoTitle: "Support — WasOK",
    seoDescription:
      "Få hjelp med WasOK: kontakt support, rapporter feil og del tilbakemeldinger.",
    getHelp: {
      title: "Få Hjelp",
      body: "Vi er her for å hjelpe deg med å få mest mulig ut av WasOK. Hvis du opplever problemer eller har spørsmål, har vi flere ressurser tilgjengelig for å hjelpe deg.",
    },
    faq: {
      title: "Ofte Stilte Spørsmål",
      body: "Før du kontakter oss, sjekk vår FAQ-seksjon hvor vi svarer på de vanligste spørsmålene om WasOK. Der finner du detaljert informasjon om hvordan appen fungerer, personvern, datalagring og mer.",
    },
    contact: {
      title: "Kontakt Support",
      body: "Hvis du ikke finner svaret du leter etter, er supportteamet vårt klart til å hjelpe. Du kan nå oss på:",
      emailLabel: "E-post:",
      responseTime: "Vi svarer vanligvis innen 24-48 timer",
    },
    bugs: {
      title: "Rapportere Feil",
      body: "Fant du en feil? Vi setter pris på hjelpen din med å gjøre WasOK bedre. Når du rapporterer en feil, vennligst inkluder:",
      items: [
        "En detaljert beskrivelse av problemet",
        "Trinn for å gjenskape problemet",
        "Enhetsmodellen din og Android-versjonen",
        "Skjermbilder eller skjermopptak hvis mulig",
      ],
      sendPrefix: "Send feilrapporter til:",
    },
    featureRequests: {
      title: "Funksjonsforespørsler",
      bodyBefore: "Har du en idé til en ny funksjon? Vi vil gjerne høre fra deg! Send forslagene dine til",
      bodyAfter:
        ". Selv om vi ikke kan implementere hver forespørsel, vurderer vi nøye alle tilbakemeldinger når vi planlegger fremtidige oppdateringer.",
    },
    knownIssues: {
      title: "Kjente Problemer",
      body: "Vi er for øyeblikket klar over følgende problemer og jobber med løsninger:",
      items: [
        "Enkelte strekkoder skanner kanskje ikke i svakt lys — prøv å bruke en lommelykt",
        "Svært lange produktnotater kan ta et øyeblikk å lagre på eldre enheter",
        "Bildeminiatyrer kan se pikselerte ut på skjermer med høy oppløsning",
      ],
    },
    appUpdates: {
      title: "Appoppdateringer",
      body: "Vi lanserer jevnlig oppdateringer med nye funksjoner, forbedringer og feilrettinger. Sørg for å holde WasOK oppdatert via Google Play Store for å få de nyeste forbedringene.",
    },
    community: {
      title: "Fellesskap",
      body: "Bli med i fellesskapet vårt av brukere som tar smartere kjøpsbeslutninger med WasOK. Del tips, still spørsmål og få kontakt med andre brukere på våre sosiale kanaler.",
    },
    emergency: {
      title: "Akuttstøtte",
      body: 'Hvis du opplever et kritisk problem som hindrer deg i å bruke appen, vennligst merk e-posten din som "URGENT" i emnefeltet, så prioriterer vi forespørselen din.',
    },
    cta: {
      heading: "Trenger du fortsatt hjelp?",
      body: "Supportteamet vårt er her for deg. Ikke nøl med å ta kontakt med spørsmål eller bekymringer.",
      button: "E-post til support",
    },
  },
  advertising: {
    pageTitle: "Annonsering & Inntektsgenerering",
    seoTitle: "Annonsering — WasOK",
    seoDescription: "Hvordan WasOK forholder seg til annonsering og inntektsgenerering.",
    approach: {
      title: "Vår Tilnærming",
      body: "Hos WasOK tror vi at handlevanene og produktmeningene dine er private og personlige. Forretningsmodellen vår gjenspeiler denne kjerneverdien.",
    },
    noAds: {
      title: "Ingen Annonser",
      body: "WasOK viser ingen annonser. Vi vil aldri vise deg annonser basert på produktene du skanner, vurderingene du gir, eller andre data du oppretter i appen. Opplevelsen din med WasOK er helt annonsefri.",
    },
    noDataSelling: {
      title: "Ingen Datasalg",
      body: "Vi selger, leier ut eller deler ikke dataene dine med annonsører, datameglere eller andre tredjeparter. Siden alle dataene dine lagres lokalt på enheten din, har vi ikke engang tilgang til dem. Produktvurderingene, handlelistene og notatene dine er kun dine.",
    },
    noTracking: {
      title: "Ingen Sporing",
      body: "WasOK bruker ikke sporingspiksler, analysetjenester eller annen teknologi som overvåker atferden din eller deler informasjon med tredjeparter. Vi sporer ikke hvilke produkter du skanner, hvilke butikker du handler i, eller hvordan du bruker appen.",
    },
    sustainability: {
      title: "Hvordan Vi Forblir Bærekraftige",
      body: "Du lurer kanskje på hvordan vi holder WasOK gratis uten annonser eller datasalg. Tilnærmingen vår er enkel:",
      items: [
        {
          label: "Gratis og Åpen:",
          text: "WasOK er gratis for alle å bruke, uten premiumnivåer eller betalingsmurer",
        },
        {
          label: "Slank Drift:",
          text: "Vi holder kostnadene våre lave ved å bygge effektiv, personvernfokusert programvare",
        },
        {
          label: "Valgfrie Donasjoner:",
          text: "Brukere som elsker WasOK kan støtte oss gjennom frivillige donasjoner",
        },
        {
          label: "Åpen Kildekode:",
          text: "Vi kan tilby konsulent- eller tilpassede utviklingstjenester for organisasjoner",
        },
      ],
    },
    noAffiliate: {
      title: "Ingen Tilknyttede Lenker",
      body: "WasOK bruker ikke tilknyttede lenker eller mottar provisjoner fra forhandlere. Når du skanner et produkt, omdirigerer vi deg ikke til å kjøpe det noe sted. Appen er kun til for din personlige registerføring og beslutningstaking.",
    },
    noPromotions: {
      title: "Ingen Produktpromoteringer",
      body: "Vi aksepterer ikke betaling fra merker eller produsenter for å promotere produktene deres. WasOK vil aldri foreslå produkter, fremheve bestemte merker eller påvirke vurderingene dine på noen måte. Meningene dine er dine egne.",
    },
    partnerships: {
      title: "Tredjepartspartnerskap",
      body: "WasOK samarbeider ikke med markedsføringsselskaper, dataaggregatorer eller annonsenettverk. Vi opererer uavhengig og prioriterer personvernet ditt fremfor alt annet.",
    },
    future: {
      title: "Fremtidsplaner",
      body: "Vi er forpliktet til å holde WasOK annonsefri og personvernfokusert. Hvis vi noen gang trenger å innføre en bærekraftig forretningsmodell i fremtiden, vil vi:",
      items: [
        "Kunngjøre eventuelle endringer i god tid på forhånd",
        "Aldri gå på kompromiss med personvern eller datasikkerhet",
        "Alltid tilby en måte å bruke appen uten sporing eller annonser",
        "Lytte til tilbakemeldinger og bekymringer fra brukere",
      ],
    },
    supporting: {
      title: "Støtte WasOK",
      body: "Hvis du elsker WasOK og ønsker å støtte vårt oppdrag om personvernfokusert handleminne, kan du:",
      items: [
        "Fortelle venner og familie om appen",
        "Legge igjen en positiv anmeldelse på Google Play Store",
        "Dele tilbakemeldinger og forslag med oss",
        "Vurdere å gi en frivillig donasjon (når tilgjengelig)",
      ],
    },
    cta: {
      heading: "Spørsmål om retningslinjene våre?",
      body: "Vi er transparente om hvordan WasOK opererer. Hvis du har spørsmål om vår tilnærming til personvern, inntektsgenerering eller bærekraft, vennligst ta kontakt.",
      button: "Kontakt Oss",
    },
  },
};
